import { SyntheticEvent } from 'react';
import styled from '@emotion/styled';
import Link from 'presentations/views/components/atoms/Link';
import * as tracker from 'presentations/views/helpers/analytics';
import Image from 'presentations/views/components/atoms/Image';
import { ProductType } from 'domains/models/blog_post/productType';

interface Props {
  productType: ProductType;
  position?: string;
  isHideClose?: boolean;
  className?: string;
  adId?: string | null;
  name?: string;
}
export default function () {
  const onClick = (e: SyntheticEvent<HTMLDivElement>) => {
    tracker.setEvent('click spacemarket banner');
  };
  return (
    <ExternalBannerLink
      target="_blank"
      rel="noopener"
      onClick={onClick}
      href="https://www.spacemarket.com/?utm_source=partner&utm_medium=referral&utm_campaign=jicoo"
    >
      <ExternalBannerImage
        src="campaigns/20230310/spacemarket.jpg"
        alt="SPACEMARKET"
        width={712}
        height={413}
      />
    </ExternalBannerLink>
  );
}

const ExternalBannerLink = styled(Link)`
  display: flex;
  justify-content: center;
  width: 100%;
`;
const ExternalBannerImage = styled(Image)`
  width: 100%;
  height: auto;
  max-width: 356px;
`;
